"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _AvatarWrapper = _interopRequireDefault(require("./AvatarWrapper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  & .overlay-content {\n    align-items: center;\n    background: ", ";\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    font-family: sans-serif;\n    height: 0;\n    hyphens: auto;\n    justify-content: center;\n    left: 0;\n    opacity: 0;\n    overflow: visible;\n    padding: calc(50%);\n    position: absolute;\n    text-align: center;\n    top: 0;\n    transition: opacity 300ms ease;\n    width: 0;\n  }\n\n  &:hover .overlay-content,\n  &.hover-test .overlay-content {\n    opacity: 0.85;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_AvatarWrapper.default).withConfig({
  displayName: "AvatarWrapperOverlay",
  componentId: "axniyx-0"
})(_templateObject(), _colors.SLINKY, _colors.OLAF);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapperOverlay.js
// module id = 866
// module chunks = 209 210 211 212